import styled from 'styled-components'

import BackgroundGradient from '../assets/REDESIGN_Assets/Landing/background-gradient.svg'

const GenericRow = styled.div`
  width: ${(props) => (props.width ? props.width : '100%')};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : 'unset')};
  height: ${(props) => (props.height ? props.height : 'unset')};
  flex-wrap: ${(props) => (props.wrap ? 'wrap' : 'unset')};
  min-height: ${(props) => (props.minHeight ? props.minHeight : 'unset')};
  display: flex;
  flex-direction: ${(props) => (props.flexDir ? props.flexDir : 'row')};
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: ${(props) => (props.align ? props.align : 'center')};
  position: ${(props) => (props.position ? props.position : 'relative')};
  top: ${(props) => (props.top ? props.top : 'unset')};
  left: ${(props) => (props.left ? props.left : 'unset')};
  right: ${(props) => (props.right ? props.right : 'unset')};
  bottom: ${(props) => (props.bottom ? props.bottom : 'unset')};
  padding: ${(props) => (props.padding ? props.padding : 'unset')};
  box-sizing: border-box;
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  z-index: ${(props) => (props.zIndex ? props.zIndex : 'unset')};
  font-size: ${(props) => (props.fSize ? props.fSize : 'inherit')};
  align-self: ${(props) => (props.alignSelf ? props.alignSelf : 'inherit')};
  color: ${(props) => (props.color ? props.color : 'unset')};

  &.pointer {
    cursor: pointer;
  }

  &.overflow {
    overflow-x: scroll;
  }

  &.album-container {
    @media only screen and (min-width: 1280px) {
      width: 60%;
    }
  }

  &.info-banner {
    background-color: #a1ff68;
    border-radius: 1rem;
  }

  &.sub {
    background: rgba(255, 255, 255, 0.25);
    border-radius: 19px;
    padding: 3%;
  }
  &.pointer {
    cursor: pointer;
  }
  &.choose-miazga {
    &.tablet-view {
      @media (orientation: landscape) {
        flex-direction: row;
      }
    }
  }

  &.responsive-width {
    width: 60%;
    @media only screen and (max-width: 600px) {
      width: 100%;
      /* flex-direction: column; */

      @media only screen and (max-width: 600px) {
        width: 90%;
      }
    }

    @media (min-width: 1024px) and (max-width: 1280px) {
      width: 90%;
    }

    @media (min-width: 768px) and (max-width: 1023px) {
      width: 90%;
    }
  }

  &.top-banner {
    @media (max-width: 600px) {
      flex-direction: column-reverse;
    }
  }

  &.landing-videos-section-button-row {
    @media (max-width: 1369px) {
      width: 100%;
      margin: 3% auto;
      white-space: nowrap;
    }
  }

  &.border-bottom {
    border-bottom: 1px solid rgba(255, 255, 255, 0.7);
  }

  &.opacity-background {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 19px;
  }

  &.fill-available-height {
    min-height: -moz-available;
    min-height: -webkit-fill-available;
    min-height: fill-available;
  }

  &.google-button {
    background-color: #342152;
    padding: 5% 10%;
    border-radius: 19px;
  }

  &.facebook-button {
    background-color: #5868bb;
    padding: 5% 10%;
    border-radius: 19px;
  }

  &.email-button {
    background-color: #a1ff68;
    padding: 5% 10%;
    border-radius: 19px;
  }

  &.pointer {
    cursor: pointer;
  }

  &.time {
    input {
      border: none;
      background-color: transparent;
      color: white;
      font-family: 'Nunito';
      font-size: inherit;
    }
  }

  /* Hour */

  /* Minute */
  input[type='time']::-webkit-datetime-edit-minute-field {
    color: #ffffff;
    opacity: 0.6;
  }
  input[type='text'] {
    cursor: text;
  }

  &.mainpage-header-row {
    @media (min-width: 1024px) and (max-width: 1280px) {
      width: 90%;
    }

    @media (min-width: 768px) and (max-width: 1023px) {
      width: 90%;
    }
  }

  &.landing {
    background: url(${BackgroundGradient});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
    flex-wrap: wrap;
  }
`

export default GenericRow
